
import build from "../assets/img/product/Build1.jpg";
import build1 from "../assets/img/product/Build2.jpg";
import build2 from "../assets/img/product/Build3.jpg";
import build3 from "../assets/img/product/Build4.jpg";
import build4 from "../assets/img/product/Build5.jpg";
import build21 from "../assets/img/product/2Build.jpg";
import build22 from "../assets/img/product/2Build1.jpg";
import build23 from "../assets/img/product/2Build2.jpg";
import { getApi, getApiByParams, postApi } from "../apis";

// let publicUrl = process.env.PUBLIC_URL + '/'
// const build = `${publicUrl}assets/img/product/2Build.jpg`;
// const build1 = `${publicUrl}assets/img/product/2Build1.jpg`;
// const build2 = `${publicUrl}assets/img/product/2Build2.jpg`;
// const build3 = `${publicUrl}assets/img/product/2Build3.jpg`;
// const build4 = `${publicUrl}assets/img/product/2Build4.jpg`;
// const build21 = `${publicUrl}assets/img/product/2Build5.jpg`;
// const build22 = `${publicUrl}assets/img/product/2Build6.jpg`;
// const build23 = `${publicUrl}assets/img/product/Build1.jpg`;

const Properties = [
    /* UK Properties
    {
        id: 1, price: '£595', address: 'Cross Street, Firgrove, OL16', location: 'Rochdale', bedrooms: 1, bathrooms: 1, images: [build, build1, build2, build3, build4], status: "For Sell", landSize: '100 sqft',
        type: "Appartment", title: "Golden Urban House For Sell",
    },
    {
        id: 2, price: '£900', address: 'Oakhurst Drive, Birch Hill Clock Tower, OL12', location: 'Rochdale', bedrooms: 2, bathrooms: 2, images: [build, build1, build2, build3, build4], status: "For Sell", landSize: '100 sqft',
        type: "Office", title: "Golden Urban House For Sell",
    }
    */
    {
        id: 1, price: '₹45,00,000', address: 'MIG-535, Road No. 4, KPHB Colony', location: 'Hyderabad', bedrooms: 2, bathrooms: 2, images: [build, build1, build2, build3, build4], status: "For Sell", landSize: '1200 sqft',
        type: "Apartment", title: "Modern Apartment in KPHB", country: "India"
    },
    {
        id: 2, price: '₹65,00,000', address: 'Plot 123, Manikonda', location: 'Hyderabad', bedrooms: 3, bathrooms: 2, images: [build, build1, build2, build3, build4], status: "For Sell", landSize: '1500 sqft',
        type: "Villa", title: "Spacious Villa in Manikonda", country: "India"
    },
    {
        id: 3, price: '₹25,000', address: 'Apartment 404, Sri Sai Towers, Madhapur', location: 'Hyderabad', bedrooms: 2, bathrooms: 2, images: [build, build1, build2, build3, build4], status: "For Rent", landSize: '1100 sqft',
        type: "Apartment", title: "Furnished Apartment in Madhapur", country: "India"
    },
    {
        id: 4, price: '₹85,00,000', address: 'Villa 7, Palm Meadows, Kompally', location: 'Hyderabad', bedrooms: 4, bathrooms: 3, images: [build21, build22, build23], status: "For Sell", landSize: '2200 sqft',
        type: "Villa", title: "Luxury Villa in Palm Meadows", country: "India"
    },
    {
        id: 5, price: '₹35,000', address: 'Office Space 303, Cyber Towers, Hi-tech City', location: 'Hyderabad', bedrooms: 0, bathrooms: 2, images: [build21, build22, build23], status: "For Rent", landSize: '1000 sqft',
        type: "Office", title: "Prime Office Space in Hi-tech City", country: "India"
    },
    {
        id: 6, price: '₹55,00,000', address: 'Plot 45, Green Valley, Kondapur', location: 'Hyderabad', bedrooms: 3, bathrooms: 3, images: [build21, build22, build23], status: "For Sell", landSize: '1800 sqft',
        type: "Apartment", title: "Premium Apartment in Kondapur", country: "India"
    },
];

export const getProperties = (param) => {
    return new Promise((resolve, rejects) => {
        if (param) {
            resolve(Properties);
        } else {
            rejects("New Error");
        }
    })
}

export const getAllProperties = (filters) => {
    return getApiByParams('/api/property', filters);
}

// New filter-based property search
export const searchProperties = (filters) => {
    return getApiByParams('/api/property-filter/search', filters);
}

// Get filter options for dropdowns
export const getFilterOptions = () => {
    return getApi('/api/property-filter/options');
}

// Get filter options for specific property types
export const getResidentialFilterOptions = () => {
    return getApi('/api/residential-properties/filter-options');
}

export const getCommercialFilterOptions = () => {
    return getApi('/api/commercial-properties/filter-options');
}

export const getAgriculturalFilterOptions = () => {
    return getApi('/api/agricultural-lands/filter-options');
}

// Get featured properties - Updated to use dedicated featured properties API
export const getFeaturedProperties = (filters = {}) => {
    return getApiByParams('/api/featured-properties', filters);
}

// Get featured properties by category
export const getFeaturedPropertiesByCategory = (category, filters = {}) => {
    return getApiByParams(`/api/featured-properties/${category}`, filters);
}

// Get featured properties count
export const getFeaturedPropertiesCount = () => {
    return getApi('/api/featured-properties/count');
}

// Get properties by type using specific APIs
export const getResidentialProperties = (filters = {}) => {
    return getApiByParams('/api/residential-properties', filters);
}

export const getCommercialProperties = (filters = {}) => {
    return getApiByParams('/api/commercial-properties', filters);
}

export const getAgriculturalLands = (filters = {}) => {
    return getApiByParams('/api/agricultural-lands', filters);
}

// Search functions for each property type
export const searchResidentialProperties = (filters = {}) => {
    return getApiByParams('/api/residential-properties/search', filters);
}

export const searchCommercialProperties = (filters = {}) => {
    return getApiByParams('/api/commercial-properties/search', filters);
}

export const searchAgriculturalLands = (filters = {}) => {
    return getApiByParams('/api/agricultural-lands/search', filters);
}

// Universal search function that routes to appropriate search endpoint
export const searchPropertiesByType = (propertyType, filters = {}) => {
    switch (propertyType.toLowerCase()) {
        case 'residential':
            return searchResidentialProperties(filters);
        case 'commercial':
            return searchCommercialProperties(filters);
        case 'agricultural':
            return searchAgriculturalLands(filters);
        default:
            // Fallback to universal search for unknown types
            return getApiByParams('/api/property-filter/search', { ...filters, type: propertyType });
    }
}

// Get properties by type (residential, commercial, agricultural) - Updated to use specific APIs
export const getPropertiesByType = (propertyType, filters = {}) => {
    switch (propertyType.toLowerCase()) {
        case 'residential':
            return getResidentialProperties(filters);
        case 'commercial':
            return getCommercialProperties(filters);
        case 'agricultural':
            return getAgriculturalLands(filters);
        default:
            // Fallback to universal search for unknown types
            return getApiByParams('/api/property-filter/search', { ...filters, type: propertyType });
    }
}

// Get individual property by ID - Updated to use specific APIs
export const getPropertyById = async (id) => {
    // Try to get property from each specific API until we find it
    const propertyTypes = [
        { type: 'residential', endpoint: '/api/residential-properties/' },
        { type: 'commercial', endpoint: '/api/commercial-properties/' },
        { type: 'agricultural', endpoint: '/api/agricultural-lands/' }
    ];

    for (const { type, endpoint } of propertyTypes) {
        try {
            const response = await getApi(endpoint + id);
            if (response) {
                // Add property type to the response for frontend use
                return { ...response, propertyCategory: type };
            }
        } catch (error) {
            // Continue to next type if not found
            continue;
        }
    }

    // If not found in specific APIs, try the old generic endpoint as fallback
    try {
        return await getApi('/api/property/' + id);
    } catch (error) {
        throw new Error('Property not found');
    }
}

// Get individual property by ID and type (more efficient if type is known)
export const getPropertyByIdAndType = (id, propertyType) => {
    switch (propertyType.toLowerCase()) {
        case 'residential':
            return getApi('/api/residential-properties/' + id);
        case 'commercial':
            return getApi('/api/commercial-properties/' + id);
        case 'agricultural':
            return getApi('/api/agricultural-lands/' + id);
        default:
            return getApi('/api/property/' + id);
    }
}

// Legacy function - kept for backward compatibility
export const getByProperties = (id) => {
    return getPropertyById(id);
}
export const getPropertiesBySearchParams = (params) => {
    return getApiByParams('/api/property/searchParams', params);
}
export const createEvaluation = (value) => {
    return postApi('/api/evaluations', value);
}
export const createArrangeVewing = (value) => {
    return postApi('/api/arrange/indian-arrange-view', value);
}
export const getIndianArrangeViews = () => {
    return getApi('/api/arrange/indian-views');
}
export const createSalesAndLettings = (value) => {
    return postApi('/api/liveChat', value);
}